import { createPortal } from 'react-dom';
import LivreImmersif from '../../../pages/EspaceEleve/LivreImmersif';

/**
 * Le texte d'une question de compréhension (variante ou forme parallèle), pour que le prof le lise : le même livre
 * que l'élève (LivreImmersif, 12/10/2026), en relecture (« Revenir à la question » ferme). Au-dessus de tout : il
 * s'ouvre aussi depuis la fenêtre de modification (z-[10001]). Un clic dans le livre remonte quand même à la carte
 * (arbre React, malgré le portail) : il est arrêté à la racine.
 */
const FenetreTexteSupport = ({ support, onClose }) => createPortal(
  <div onClick={(e) => e.stopPropagation()}>
    <LivreImmersif
      key={support.id}
      titre={support.titre}
      supportId={support.id}
      pages={support.pages}
      onFermer={onClose}
      auDessus
    />
  </div>,
  document.body,
);

export default FenetreTexteSupport;
